
import IconClose from '@svg/IconClose.svg'
import IconTooltipTriangle from '@svg/IconTooltipTriangle.svg'

import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    'icon-close': IconClose,
    'icon-tooltip-triangle': IconTooltipTriangle,
  },
})
export default class HintTooltipVue extends Vue {
  @Prop({ type: String, default: '' })
  public copy!: string
  @Prop({ type: String, default: '' })
  public title!: string
  @Prop({ type: Number, default: 5000 })
  public timeout!: number
  @Prop({
    type: String,
    default: 'left',
    validator: (value: string) => ['left', 'right', 'top', 'bottom', 'align-lb', 'align-rb', 'align-lc', 'align-rc'].includes(value),
  })
  public position!: string
  @Prop({
    type: String,
    default: 'rt',
    validator: (value: string) => ['tl', 'tr', 'tc', 'bl', 'br', 'bc', 'lt', 'lb', 'lc', 'rt', 'rb', 'rc'].includes(value),
  })
  public arrowPosition!: string
  @Prop({ type: String, default: '', validator: (value: string) => ['', 'xs', 'sm', 'md', 'lg'].includes(value) })
  public size!: string
  @Prop({ type: Boolean, default: true })
  public hasCloseButton!: boolean
  @Prop({ type: Boolean, default: true })
  public hasArrow!: boolean
  @Prop({ type: String, default: '' })
  public customInlineStyles!: string
  @Prop({ type: Boolean, default: true })
  public autoClose!: boolean

  public isHintTooltipActive: boolean = false
  private hintTooltipTimeoutID: ReturnType<typeof setTimeout> | undefined

  public showHintTooltip() {
    this.isHintTooltipActive = true

    this.hintTooltipTimeoutID = setTimeout(() => {
      this.hideHintTooltip()
    }, this.timeout)
  }

  public hideHintTooltip() {
    this.isHintTooltipActive = false
    clearTimeout(this.hintTooltipTimeoutID)
  }

  public toggleHintTooltip() {
    if (this.isHintTooltipActive) {
      this.hideHintTooltip()
    } else {
      this.showHintTooltip()
    }
  }
}
